import React from 'react'
import { bool, func, object, string } from 'prop-types'

import ButtonStandardArrow from '@/component/Primitive/ButtonStandardArrow'
import CheckControl from '@/component/Primitive/CheckControl'
import Container from '@/component/Primitive/Container'
import FieldTemplate from '@/component/Primitive/FieldTemplate'
import Grid from '@/component/Primitive/Grid'
import Notification from '@/component/Primitive/Notification'
import Prose from '@/component/Primitive/Prose'
import Rule from '@/component/Primitive/Rule'
import SmartLink from '@/component/Primitive/SmartLink'
import Stack from '@/component/Primitive/Stack'
import TextAlign from '@/component/Primitive/TextAlign'
import TextControl from '@/component/Primitive/TextControl'
import SelectControl from '@/component/Primitive/SelectControl'

const RegisterForm = ({
  formData,
  onChange,
  onSubmit,
  loading,
  error,
  success,
  validation
}) => (
  <form onSubmit={onSubmit}>
    <Container gutter center size="m">
      <Stack gap="l">
        <Stack gap="m">
          <Grid gutter="default">
            <Grid.Item width={[1, 1 / 2]}>
              <FieldTemplate
                label="First Name"
                required
                controlName="firstName"
                feedback={validation && validation.firstName}
                status={validation && validation.firstName && 'error'}
                autoComplete="given-name"
              >
                <TextControl
                  name="firstName"
                  required
                  onChange={onChange}
                  value={formData.firstName}
                />
              </FieldTemplate>
            </Grid.Item>
            <Grid.Item width={[1, 1 / 2]}>
              <FieldTemplate
                label="Last Name"
                required
                controlName="lastName"
                feedback={validation && validation.lastName}
                status={validation && validation.lastName && 'error'}
                autoComplete="family-name"
              >
                <TextControl
                  name="lastName"
                  required
                  onChange={onChange}
                  value={formData.lastName}
                />
              </FieldTemplate>
            </Grid.Item>
          </Grid>

          <FieldTemplate
            label="Email Address"
            required
            controlName="emailAddress"
            feedback={validation && validation.emailAddress}
            status={validation && validation.emailAddress && 'error'}
          >
            <TextControl
              type="email"
              name="emailAddress"
              required
              onChange={onChange}
              value={formData.emailAddress}
              autoComplete="email"
            />
          </FieldTemplate>

          <FieldTemplate label="Phone Number" controlName="phoneNumber">
            <TextControl
              name="phoneNumber"
              type="tel"
              feedback={validation && validation.phoneNumber}
              onChange={onChange}
              value={formData.phoneNumber}
              autoComplete="tel"
              required
            />
          </FieldTemplate>

          <FieldTemplate
            template="check"
            label="I'd like Citygate to send me news and offers via the following:"
            controlName="emailNewsletter"
          >
            <CheckControl
              type="checkbox"
              name="emailNewsletter"
              onChange={onChange}
            >
              Email
            </CheckControl>
          </FieldTemplate>
          <Rule muted />
          <FieldTemplate
            template="check"
            controlName="tcs"
            feedback={validation && validation.tcs}
            status={validation && validation.tcs && 'error'}
          >
            <CheckControl type="checkbox" name="tcs" onChange={onChange}>
              <Prose>
                I accept the Citygate{' '}
                <SmartLink href="https://www.citygate.co.uk/legal">
                  terms and conditions
                </SmartLink>
              </Prose>
            </CheckControl>
          </FieldTemplate>
          <Rule muted />
        </Stack>

        {error && <Notification status="error">{error}</Notification>}
        {success && (
          <Notification status="success">
            Please check your email for a verification link.
          </Notification>
        )}

        <TextAlign right>
          <ButtonStandardArrow
            type="submit"
            loading={loading}
            disabled={success}
          >
            Register
          </ButtonStandardArrow>
        </TextAlign>
      </Stack>
    </Container>
  </form>
)

RegisterForm.propTypes = {
  formData: object,
  onChange: func,
  onSubmit: func,
  error: string,
  validation: object,
  loading: bool,
  success: bool
}

export default RegisterForm
